import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { socket } from "../App";
import { SOCKET } from "../constants/constants";
import { isNonCustodialWallet, enrichBalanceWithPairWallet } from "../services/wallet/linkedWallet.utils";
import { setActivePairBalance } from "../features/ats/atsSlice";

/**
 * Listens for BitGo wallet balance updates pushed after webhook-triggered refreshes.
 * Payload matches GET /wallet/v1/user/get_balance `data` field.
 */
export function useWalletBalanceSocket() {
  const dispatch = useDispatch();
  const isUserLogin = useSelector((state) => state?.persist?.isUserLogin);
  const selectedTradeWallet = useSelector((state) => state?.ats?.selectedTradeWallet);
  const selectedPair = useSelector((state) => state?.ats?.selectedPair);
  const linkedWallets = useSelector((state) => state?.ats?.linkedWallets ?? []);

  useEffect(() => {
    if (!isUserLogin) return undefined;

    const onWalletBalance = (balance) => {
      if (!balance || typeof balance !== "object") return;
      if (selectedTradeWallet && isNonCustodialWallet(selectedTradeWallet)) {
        return;
      }
      dispatch(
        setActivePairBalance(
          enrichBalanceWithPairWallet(
            balance,
            selectedPair,
            selectedTradeWallet,
            linkedWallets,
          ),
        ),
      );
    };

    socket.on(SOCKET.USER_WALLET_BALANCE, onWalletBalance);
    console.log("[useWalletBalanceSocket] listening", SOCKET.USER_WALLET_BALANCE);

    return () => {
      socket.off(SOCKET.USER_WALLET_BALANCE, onWalletBalance);
    };
  }, [dispatch, isUserLogin, linkedWallets, selectedPair, selectedTradeWallet]);
}

export default useWalletBalanceSocket;
